class LiveSearchWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="q"]');
    this.liveSearch = this.querySelector("live-search");

    if (!this.input || !this.liveSearch) return;

    this.toggleClearVisibility();

    this.input.addEventListener("input", () => {
      this.liveSearch.setAttribute("q", this.input.value);
      this.toggleClearVisibility();
    });

    const handleClear = () => {
      this.input.value = "";
      this.liveSearch.setAttribute("q", "");
      this.toggleClearVisibility();
    };

    this.addEventListener('click', (e) => {
      const clear = e.target.closest('[data-clear]');

      if (!clear) return;

      handleClear();
    });

    this.addEventListener("live-search-wrapper:clear", handleClear);

    this.handleMenuClose = () => handleClear();

    document.addEventListener("mobile-menu:close", this.handleMenuClose);
  }

  disconnectedCallback() {
    document.removeEventListener("mobile-menu:close", this.handleMenuClose);
  }

  toggleClearVisibility() {
    this.toggleAttribute("active", this.input.value.length);
    this.toggleAttribute("show-clear", this.input.value.length);
  }
}

if (!customElements.get("live-search-wrapper")) {
  customElements.define("live-search-wrapper", LiveSearchWrapper);
}
